module.exports = __webpack_public_path__ + "img/welsh_government.80343864.png";